import styled from "@emotion/styled";
import InnoIcons from "@InnoIcons/";
import theme from "@theme/";

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled.button`
  background: white;
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  // min-width: 180px;
  min-width: ${(props) => props.minWidth || "180px"};

  justify-content: space-between;
  transition: all 0.2s ease;

  /* subtle shadow by default */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    border-color: #d1d5db;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15); /* slightly stronger on hover */
  }

  /* Open state */
  ${(props) =>
    props.isOpen &&
    `
    border-color: ${theme.colors.themeColor};
    box-shadow: 0 0 0 2px ${theme.colors.themeColor}, 0 4px 12px rgba(0,0,0,0.15);
  `}

  /* Active state (filter applied) */
  ${(props) =>
    props.isActive &&
    `
    border-color: ${theme.colors.themeColor}; 
    background-color:${theme.colors.buttonbackgroundfilter}; /* subtle light orange */
    color: ${theme.colors.themeColor};
  `}
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  margin-top: 6px;
  min-width: 260px;
  z-index: 1000;
  opacity: ${(props) => (props.isOpen ? "1" : "0")};
  transform: ${(props) =>
    props.isOpen ? "translateY(0)" : "translateY(-10px)"};
  transition: all 0.25s ease;
  pointer-events: ${(props) => (props.isOpen ? "auto" : "none")};
`;

const OptionGroup = styled.div`
  padding: 16px;
  margin-bottom: 6px;

  .section-label {
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    display: inline-block;
  }
`;

const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0;
`;

const DateInput = styled.input`
  height: 36px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: border 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    outline: none;
    border-color: #f97316;
    box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.15);
  }
`;

const DateSeparator = styled.span`
  font-size: 14px;
  color: #6b7280;
`;

const RadioRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;

  .MuiFormControlLabel-label {
    font-size: 14px;
    color: #374151;
  }

  .MuiRadio-root {
    padding: 2px;
  }
`;

const DropdownFooter = styled.div`
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

const UpdateButton = styled.button`
  background: ${theme.gradient.themeGradient};
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.gradient.themeGradient};
  }
`;

const ClearButton = styled.button`
  background: transparent;
  color: #6b7280;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }
`;

const ChevronIcon = styled(InnoIcons.KeyboardArrowDownIcon)`
  transition: transform 0.2s ease;
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  color: ${(props) =>
    props.isActive ? `${theme.colors.themeColor}` : "black"};
`;

const SC = {
  DropdownContainer,
  DropdownButton,
  DropdownMenu,
  OptionGroup,
  InputRow,
  DateInput,
  DateSeparator,
  RadioRow,
  DropdownFooter,
  UpdateButton,
  ClearButton,
  ChevronIcon,
};

export default SC;
